import type { TermsAcceptanceLog } from '../../types/generated/models/terms-acceptance-log'
import type { TermsAcceptanceLogPaginatedApiResponse } from '../../types/generated/models/terms-acceptance-log-paginated-api-response'
import type { PaginationInfo } from '../../types/generated/models/pagination-info'

/* ── State interface ── */

export interface TermsAcceptanceLogsState {
  data: TermsAcceptanceLog[]
  pagination: PaginationInfo
  loading: boolean
  error: boolean | null
  errorMessage: string
}

/* ── Action types ── */

export const GET_TERMS_ACCEPTANCE_LOGS = 'GET_TERMS_ACCEPTANCE_LOGS'
export const GET_TERMS_ACCEPTANCE_LOGS_SUCCESS = 'GET_TERMS_ACCEPTANCE_LOGS_SUCCESS'
export const GET_TERMS_ACCEPTANCE_LOGS_FAIL = 'GET_TERMS_ACCEPTANCE_LOGS_FAIL'

/* ── Initial state ── */

const initialState: TermsAcceptanceLogsState = {
  data: [],
  pagination: {
    pageNumber: 1,
    pageSize: 50,
    totalCount: 0,
    totalPages: 0
  },
  loading: false,
  error: null,
  errorMessage: ''
}

/* ── Reducer ── */

export default function termsAcceptanceLogsReducer(
  state: TermsAcceptanceLogsState = initialState,
  action: any = {}
): TermsAcceptanceLogsState {
  switch (action.type) {
    case GET_TERMS_ACCEPTANCE_LOGS:
      return {
        ...state,
        loading: true,
        error: null,
        errorMessage: ''
      }

    case GET_TERMS_ACCEPTANCE_LOGS_SUCCESS: {
      const response = action.payload.data as TermsAcceptanceLogPaginatedApiResponse
      if (response.success) {
        return {
          ...state,
          data: (response.data ?? []) as TermsAcceptanceLog[],
          pagination: (response.pagination ?? initialState.pagination) as PaginationInfo,
          loading: false,
          error: false,
          errorMessage: ''
        }
      }
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: response.error || 'Failed to fetch terms acceptance logs'
      }
    }

    case GET_TERMS_ACCEPTANCE_LOGS_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.payload?.error || 'Failed to fetch terms acceptance logs'
      }

    default:
      return state
  }
}
